/*
==================================================
CLASS-STATISTICS-BAR.JS
==================================================
*/


let classStatisticsItems, decks, flashcards, learners;

const classStatisticsBar = {

  init: function () {
    classStatisticsItems = document.querySelector('.class-statistics-items');
    decks = classStatisticsItems.querySelector('.decks');
    flashcards = classStatisticsItems.querySelector('.flashcards');
    learners = classStatisticsItems.querySelector('.learners');

    /*
    ==================================================
    WIRE DOM ELEMENTS
    ==================================================
    */

    if (classStatisticsItems) {
      this.handleCounters();
    }
  },

  /*
  ==================================================
  EVENT HANDLERS
  ==================================================
  */

  handleCounters() {
    this.animateCounter(decks);
    this.animateCounter(flashcards);
    this.animateCounter(learners);
  },
    
  /*
  ==================================================
  LOCAL UTILS
  ==================================================
  */

  animateCounter(element) {
    let lastValue = element.getAttribute('data-value');
    let initialValue = 0;
    let startTime = null;
    let currentTime = Date.now();
    let ANIMATION_DURATION = 1300 //ms;

    const step = (currentTime) => {
      startTime ? startTime : startTime = currentTime;

      const progress = Math.min((currentTime - startTime) / ANIMATION_DURATION, 1);

      element.innerHTML = this.getDecimalSeparator(Math.floor(progress * (lastValue - initialValue)));

      progress < 1 ? requestAnimationFrame(step) : cancelAnimationFrame(requestAnimationFrame(step));
    };

    requestAnimationFrame(step);
  },

  getDecimalSeparator(integer) {
    return integer.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  },
};

export default classStatisticsBar;